// extracted by mini-css-extract-plugin
export default {"divkitHide":"index__divkitHide--2v-xh","divkit":"index__divkit--3GZFX"};